/**
 * apiFetch — thin wrapper around fetch that automatically attaches the
 * Supabase JWT as an Authorization: Bearer header.
 */
import { supabase } from './supabase/client';

type FetchOptions = Omit<RequestInit, 'credentials'>;

export async function apiFetch(
  url: string,
  options: FetchOptions = {}
): Promise<Response> {
  // getSession() returns the cached in-memory session synchronously after first
  // load — no network call, no timeout needed. If the session is expired it
  // auto-refreshes once; if truly missing the call proceeds with no token and
  // the server returns 401 (correct behaviour).
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const token = session?.access_token ?? null;

  const headers = new Headers(options.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  if (
    options.body &&
    typeof options.body === 'string' &&
    !headers.has('Content-Type')
  ) {
    headers.set('Content-Type', 'application/json');
  }

  return fetch(url, { ...options, headers });
}
